import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { LandingPageModule } from './landing-page/landing-page.module';
import { UserDashboardModule } from './user-dashboard/user-dashboard.module';
import { AppRoutingModule } from './app-routing.module';
import { HeaderModule } from './ui-components/header/header.module';
import { UserModule } from './users/user.module';
import { NavigationModule } from './ui-components/navigation/navigation.module';

import { AppComponent } from './app.component';
import { PageConfig } from '../config/page.config';
import { SpinnersModule } from './ui-components/spinners/spinners.module';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { InvalidPermissionsModule } from './invalid-permissions/invalid-permissions.module';
import { AnalyticsModule } from './analytics/analytics.module';
import { UrlConfig } from '../config/url-config';
import { SideNavigationLayoutComponent } from './layouts/side-navigation-layout/side-navigation-layout.component';
import { OneColumnLayoutComponent } from './layouts/one-column-layout/one-column-layout.component';
import { RedirectToExternalSso } from './users/redirect-to-external-sso.service';
import { AlertsModule } from './ui-components/alerts/alerts.module';
import { DateTimeService } from 'app/services/date-time.service';
import { UsanFormsModule } from './applications/forms/usan-forms.module';
import { FooterModule } from './layouts/footer/footer.module';
import { AdminModule } from './admins/admin.module';
import { ApplicantsModule } from './applicants/applicants.module';
import { ApiTokenInterceptorInterceptor } from './api-token-interceptor.interceptor';


@NgModule({
  declarations: [
    AppComponent,
    SideNavigationLayoutComponent,
    OneColumnLayoutComponent
  ],
  imports: [
    AnalyticsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    HeaderModule,
    FooterModule,
    AlertsModule,
    LandingPageModule,
    ApplicantsModule,
    NavigationModule,
    PageNotFoundModule,
    InvalidPermissionsModule,
    ReactiveFormsModule,
    SpinnersModule,
    UserModule,
    UsanFormsModule,
    AdminModule,
    UserDashboardModule
  ],
  providers: [
    DateTimeService,
    PageConfig,
     {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiTokenInterceptorInterceptor,
      multi: true
    },
    { provide: UrlConfig, useValue: (window as any)['environment']['urls'] },
    RedirectToExternalSso,
  ],
  // schemas: [
  //   CUSTOM_ELEMENTS_SCHEMA
  // ],
  bootstrap: [
    AppComponent
   ]
})
export class AppModule { }
